import { render, staticRenderFns } from "./CriarConta.vue?vue&type=template&id=b7507a90&scoped=true"
import script from "./CriarConta.vue?vue&type=script&lang=js"
export * from "./CriarConta.vue?vue&type=script&lang=js"
import style0 from "./CriarConta.vue?vue&type=style&index=0&id=b7507a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7507a90",
  null
  
)

export default component.exports